<template>
    <div class="flex flex-wrap md:flex-nowrap">
        <div class="col-12 md:col-6 lg:col-6 banner-vertical-principal"></div>
        <div v-if="+status > 0" class="col-12 md:col-6 lg:col-6 bg-gray mt-minus-15">
            <div class="px-6 pt-4 md:px-6 flex flex-column lg:px-7 relative h-full">
                <div class="flex flex-row flex-nowrap align-items-center justify-content-center">
                    <div class="w-81rem m-2 md:m-4 lg:my-1">
                        <h1 class="font-bold text-2xl text-primary md:text-4xl">
                            {{ title }}
                        </h1>
                        <p class="mt-5 w-full md:w-8">
                            {{ subtitle }}
                        </p>
                        <div v-if="+status < 3">
                            <span class="block mt-5 font-bold w-full text-lg text-primary">
                                {{ couponStore.campaingName }}
                            </span>

                            <QrGenerator
                                class="mt-6"
                                :qvalue="couponStore.code"
                                :q-size="250"
                                :q-color="color"
                            />

                            <h2 class="text-primary font-bold text-2xl mt-5 mb-3 md:text-3xl">
                                Código de Cupón
                            </h2>
                            <span class="text-primary font-bold text-lg">
                                {{ couponStore.code }}
                            </span>

                            <p class="bottom-0 md:absolute mt-3">
                                Código canjeable a través de la red de concesionarios dentro de la
                                República Mexicana. Aplica únicamente para los Estados
                                participantes, bajo las condiciones establecidas dentro de la
                                campaña.
                            </p>
                        </div>
                        <div v-else>
                            <PrimeButton
                                type="button"
                                class="rounded w-10 md:w-6 lg:w-8 xl:w-3 mt-6 block"
                                label="Reintentar"
                                @click="returnHome"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import QrGenerator from "../components/QrGenerator.vue";
import { useCouponStore } from "../stores/cupones/couponStore";
import { useGtag } from "vue-gtag-next";

export default defineComponent({
    name: "FormClient",
    components: {
        QrGenerator,
    },
    setup() {
        const color = import.meta.env.VITE_BRAND !== "vw" ? "#000000" : "#001E50";
        const route = useRoute();
        const router = useRouter();
        const couponStore = useCouponStore();
        const { event } = useGtag();
        const status = route.query.status || 0;
        let title = "";
        let subtitle = "";

        /**
         * Método para cambiar los tíulos de la pagina dependiendo del status que tenga el cupón
         * @param {number} status - el statusId del cupón.
         * @return {null} Sin respuesta
         */
        switch (+status) {
            case 1:
                title = "¡Tu cupón ha sido generado!";
                subtitle =
                    "¡Excelente! Tu cupón ha sido generado correctamente. Por favor, revisa tu correo electrónico para obtener más detalles sobre cómo canjearlo.";
                event(`new_coupon_${import.meta.env.VITE_BRAND}`, {
                    event_category: couponStore.campaingName,
                    event_label: couponStore.code,
                });
                console.log(import.meta.env.VITE_BRAND, couponStore.campaingName, couponStore.code);
                break;
            case 2:
                title = "Cupón activo";
                subtitle =
                    "Actualmente tienes un cupón activo que aún no has canjeado. Visita a tu concesionario para canjear tu cupón.";
                break;
            case 3:
                title = "¡Cupón canjeado!";
                subtitle =
                    "Tu cupón ha sido canjeado con éxito. Si deseas generar un nuevo cupón, por favor utiliza una dirección de correo electrónico diferente.";
                break;
        }

        /**
         * Función para poder volver a la vista principal
         */
        function returnHome() {
            router.go(-1);
        }

        return {
            color,
            status,
            title,
            subtitle,
            returnHome,
            couponStore,
        };
    },
});
</script>

<style scoped>
.mt-minus-15 {
    margin-top: -15px;
}
</style>
